import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { NavLink, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logoImg from "../assets/logo.png";

const NavBar = ({ textColor = "#fff" }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Opposite background color for scroll
  const oppositeBg = textColor === "#000" ? "#fff" : "#000";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setMenuOpen((v) => !v);

  // Mark PRODUCTS as active on both /products and /product/:id
  const isProductsActive =
    location.pathname === "/products" ||
    /^\/product\/[^/]+$/.test(location.pathname);

  return (
    <>
      <nav
        className="navbar"
        style={{
          color: textColor,
          backgroundColor: scrolled ? oppositeBg : "transparent",
          transition: "background-color 0.3s ease",
        }}
      >
        {/* Left logo */}
        <NavLink to="/" className="logo-link">
          <img src={logoImg} alt="Holland Tahini Logo" className="logo" />
        </NavLink>

        {/* Desktop nav */}
        <ul className="nav-links nav-links--desktop">
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={{ color: textColor }}
            >
              HOME
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/products"
              className={() =>
                `nav-link ${isProductsActive ? "active" : ""}`
              }
              style={{ color: textColor }}
            >
              PRODUCTS
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={{ color: textColor }}
            >
              ABOUT
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/recipes"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={{ color: textColor }}
            >
              MENU
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/faq"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={{ color: textColor }}
            >
              FAQ
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={{ color: textColor }}
            >
              CONTACT
            </NavLink>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <button className="hamburger" onClick={toggleMenu} aria-label="Menu">
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </nav>

      {/* Mobile menu overlay */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <NavLink to="/" end onClick={toggleMenu}>
              HOME
            </NavLink>
          </li>
          <li>
            <NavLink to="/products" onClick={toggleMenu}>
              PRODUCTS
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={toggleMenu}>
              ABOUT
            </NavLink>
          </li>
          <li>
            <NavLink to="/recipes" onClick={toggleMenu}>
              RECIPES
            </NavLink>
          </li>
          <li>
            <NavLink to="/faq" onClick={toggleMenu}>
              FAQ
            </NavLink>
          </li>
          <li>
            <NavLink to="/contact" onClick={toggleMenu}>
              CONTACT
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Backdrop */}
      <div
        className={`mobile-backdrop ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      />
    </>
  );
};

export default NavBar;
